export default Object.freeze({
  userLoggingIn: 'userLoggingIn',
  userLoggedOff: 'userLoggedOff',
  authenticationNeeded: 'authenticationNeeded',
  insufficientPrivileges: 'insufficientPrivileges',
  sessionExpired: 'sessionExpired',
  needReconnection: 'needReconnection',
  userInactive: 'userInactive'
});
